"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageEditor = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactEasyCrop = _interopRequireDefault(require("react-easy-crop"));
var _ImageEditor = require("./ImageEditor.helpers");
var _ImageEditor2 = require("./ImageEditor.styles");
var _ImageEditor3 = require("./ImageEditor.labels");
var _hooks = require("../../hooks");
var _Input = require("../Input");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ImageEditor = exports.ImageEditor = /*#__PURE__*/_react.default.memo(props => {
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const getLabel = (0, _hooks.useLabels)({
    labels: _ImageEditor3.labels
  });
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const {
    image,
    minZoom = 1,
    maxZoom = 3,
    step = 0.1,
    cropShape = 'round',
    onEditComplete
  } = props;
  const [crop, setCrop] = (0, _react.useState)({
    x: 0,
    y: 0
  });
  const [zoom, setZoom] = (0, _react.useState)(1);
  const styles = (0, _ImageEditor2.useStyles)();
  const isReady = (0, _react.useRef)(false);
  const zoomRef = (0, _react.useRef)(null);
  const intervalRef = (0, _react.useRef)();
  const handleZoomChange = (0, _react.useCallback)(value => {
    setZoom(Number(value));
  }, []);
  const handleCropperZoomChange = (0, _react.useCallback)(zoom => {
    setZoom(zoom);
  }, []);
  const handleCropChange = (0, _react.useCallback)(point => setCrop(point), []);
  const handleCropComplete = (0, _react.useCallback)((croppedArea, croppedAreaPixels) => {
    if (image && isReady.current) {
      (0, _ImageEditor.getCroppedImg)(image, croppedAreaPixels).then(croppedImage => {
        if (onEditComplete) {
          onEditComplete(croppedImage);
        }
      });
    }
  }, [image, isReady, onEditComplete]);
  const zooming = factor => {
    if (!zoomRef.current) {
      zoomRef.current = zoom;
    }
    zoomRef.current = Number((zoomRef.current + factor * step).toFixed(1));
    if (zoomRef.current < minZoom) {
      zoomRef.current = minZoom;
    } else if (zoomRef.current > maxZoom) {
      zoomRef.current = maxZoom;
    }
    handleCropperZoomChange(zoomRef.current);
  };
  const startZoomIn = event => {
    event.preventDefault();
    event.stopPropagation();
    zooming(1);
    intervalRef.current = setInterval(zooming, 100, 1);
  };
  const startZoomOut = event => {
    event.preventDefault();
    event.stopPropagation();
    zooming(-1);
    intervalRef.current = setInterval(zooming, 100, -1);
  };
  const stopZoom = event => {
    event.preventDefault();
    event.stopPropagation();
    clearInterval(intervalRef.current);
    intervalRef.current = null;
    zoomRef.current = null;
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: image && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-ImageEditor'],
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-ImageEditor__crop'],
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactEasyCrop.default, {
          image: image,
          crop: crop,
          zoom: zoom,
          aspect: 1,
          cropShape: cropShape,
          showGrid: false,
          onCropChange: handleCropChange,
          onCropComplete: handleCropComplete,
          onZoomChange: handleCropperZoomChange,
          onMediaLoaded: mediaSize => {
            setTimeout(() => {
              isReady.current = true;
            }, 0);
          },
          minZoom: minZoom,
          maxZoom: maxZoom
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: styles['cc-ImageEditor__slider'],
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Input.Input, {
          type: "range",
          min: minZoom,
          max: maxZoom,
          step: step,
          value: zoom,
          onChange: handleZoomChange,
          ariaLabel: getLabel('zoom'),
          width: isMobileView ? `calc(100% - ${pxToRem(72)})` : 424
        }), isMobileView && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: styles['cc-ImageEditor__zoom-in'],
            onMouseDown: startZoomIn,
            onTouchStart: startZoomIn,
            onMouseUp: stopZoom,
            onMouseLeave: stopZoom,
            onTouchEnd: stopZoom
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: styles['cc-ImageEditor__zoom-out'],
            onMouseDown: startZoomOut,
            onTouchStart: startZoomOut,
            onMouseUp: stopZoom,
            onMouseLeave: stopZoom,
            onTouchEnd: stopZoom
          })]
        })]
      })]
    })
  });
});